import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  getFinancialDocumentList: (
    url: string,
    pageSize: number,
    caRefNo: string,
    cuRefNo?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/financial-document/list`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        forceCheck: false,
        sort: {
          column: 'issueDate',
          sortOrder: 'DESC',
        },
        page: 1,
        pageSize,
        filter: [
          cuRefNo && {
            column: 'cuRefNo',
            compareType: 'EQUAL',
            value: cuRefNo,
          },
          {
            column: 'caRefNo',
            compareType: 'EQUAL',
            value: caRefNo,
          },
          {
            column: 'documentType',
            compareType: 'EQUAL',
            value: 'MV',
          },
        ],
      },
    }),

  getFinancialDocumentDetail: (
    url: string,
    caRefNo: string,
    documentId?: string,
    invoiceNumExt?: string,
    varSymbol?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/financial-document/detail`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        forceCheck: false,
        caRefNo,
        documentId,
        invoiceNumExt,
        varSymbol,
      },
    }),

  getInteractionInvoiceData: (url: string, invoiceNumber: string, pageSize: number): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/document/documents`, {
      baseURL: undefined,
      params: {
        invoicenumber: invoiceNumber,
        pageSize,
      },
    }),
};
